<template>
  <div class="cause-contain">
    <div class="mt24">
      <div class="title">{{infoObj.title}}</div>
      <div class="content">
        <div class="text overflow-line">
          {{infoObj.content}}
        </div>
        <div v-if="isShowMore" class="btn" :class="isDescStatus?'':' on'" @click="showmoreDesc($event)">
          <span>{{!this.isDescStatus ? '收起' : '展开'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'file',
        props: {
            'infoObj': Object
        },
        data () {
            return {
                isShowMore: false,
                isDescStatus: true,
                newContent: ''
            }
        },
        mounted () {

        },
        created () {
            this.newContent = this.infoObj.content;
            if (this.newContent.length > 120) {
                this.isShowMore = true;
            }
        },
        methods: {
            showmoreDesc (e) {
                let el = e.currentTarget;
                el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
                el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
                // el.innerHTML = !this.isDescStatus ? '展开' : '收起';
                this.isDescStatus = !this.isDescStatus;
                this.isShowMore = true;
            }
        },
        watch: {
            // newContent (val) {
            //     console.log(val, 'ff')
            // }
            // 'infoObj.content' (val) {
            //     debugger
            //     console.log(val)
            //     this.newContent = val.content;
            //     console.log(this.newContent.length, 'ffffff')
            //     if (this.newContent.length > 100) {
            //         this.isShowMore = true;
            //     }
            // }
        }
    }
</script>

<style lang="less" scoped>
.cause-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .mt24{
    margin-top: 24px;
  }
  .title{
    height:20px;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:20px;
  }
  .content{
    margin-top:12px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:5px;
    padding-bottom: 16px;
    .text{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:24px;
      margin: 0 16px;
      padding-top:16px;
      transition: all .2s;
    }
    .overflow-line{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5;
      overflow: hidden;
    }
    .btn{
      padding: 16px 16px 0 16px;
      text-align: center;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:14px;
      span{
        position: relative;
        padding-right: 11px;
      }
      span::after{
        content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../../assets/image/jiantou.png) no-repeat;
          background-size: 6px 4px;
      }
    }
    .btn.on{
      span::after{
        content:'';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 4px;
          background: url(../../../assets/image/jiantou-d.png) no-repeat;
          background-size: 6px 4px;
      }
    }
  }
}
</style>
